"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePicker = void 0;
var tslib_1 = require("tslib");
var date_fns_1 = require("date-fns");
var range_1 = (0, tslib_1.__importDefault)(require("lodash/range"));
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var padding_1 = require("../padding");
var header_1 = (0, tslib_1.__importDefault)(require("./components/header"));
var month_1 = (0, tslib_1.__importDefault)(require("./components/month"));
var TimezoneContext_1 = require("./context/TimezoneContext");
var calendar_1 = require("./hooks/calendar");
function DatePicker(props) {
    var onChange = props.onChange, disableWeekends = props.disableWeekends, maxYear = props.maxYear, minYear = props.minYear, value = props.value, minDate = props.minDate, maxDate = props.maxDate, timezone = props.timezone;
    var normalizedValue = value == null || value === '' ? undefined : value;
    var calendarContext = normalizedValue;
    var yearsRange = minYear && maxYear ? (0, range_1.default)(minYear, maxYear) : undefined;
    var currentYear = (0, date_fns_1.getYear)(new Date());
    if (!normalizedValue && yearsRange && yearsRange.includes(currentYear)) {
        calendarContext = (0, date_fns_1.setYear)(normalizedValue, currentYear).toISOString();
    }
    else if (!normalizedValue && maxYear) {
        calendarContext = (0, date_fns_1.setYear)(normalizedValue, maxYear).toISOString();
    }
    function selectDate(day) {
        onChange(day);
    }
    var calendar = (0, calendar_1.useCalendar)({
        initialValue: calendarContext,
        timezone: timezone,
    });
    return (react_1.default.createElement(TimezoneContext_1.TimezoneContext.Provider, { value: { timezone: timezone } },
        react_1.default.createElement("div", { style: { width: 224 } },
            react_1.default.createElement(padding_1.Padding, { bottom: 8 },
                react_1.default.createElement(header_1.default, { calendar: calendar, maxYear: maxYear, minYear: minYear })),
            react_1.default.createElement(month_1.default, { disableWeekends: disableWeekends, calendar: calendar, onClick: selectDate, selectedDate: normalizedValue, minDate: minDate, maxDate: maxDate }))));
}
exports.DatePicker = DatePicker;
//# sourceMappingURL=index.js.map